import { REQUEST_FACEBOOK_POST_ENGAGEMENT_SUCCESS,REQUEST_FACEBOOK_POST_ENGAGEMENT_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function facebookPostEngagement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_FACEBOOK_POST_ENGAGEMENT_SUCCESS:
     
      return { data: action.payload.data, errors: null };
    case REQUEST_FACEBOOK_POST_ENGAGEMENT_FAILURE:
     
      return { data: [], errors: action.payload.response && action.payload.response.data.errors };
    default:
      return state;
  }
}

